import { AtomEffect } from 'recoil'

/* eslint-disable prettier/prettier */
export const sessionStorageEffect =
  <T>(key: string): AtomEffect<T> =>
    ({ onSet, setSelf }) => {
      const savedValue = sessionStorage.getItem(key)
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue))
      }

      onSet((newValue, _, isReset) =>
        isReset
          ? sessionStorage.removeItem(key)
          : sessionStorage.setItem(key, JSON.stringify(newValue))
      )
    }
